require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-why-would-you-want-to-live-anywhere-else.json") })
        }
      }, "path---news-why-would-you-want-to-live-anywhere-else");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-why-would-you-want-to-live-anywhere-else!./.cache/json/news-why-would-you-want-to-live-anywhere-else.json
// module id = 866
// module chunks = 231608221292675